import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  constructor(private http: HttpClient) { }

  getSchedules() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/schsetup`);
  }

  addSchedule(username: string, orgid: any, effectiveFrom: string, effectiveTo: string, periodTimeSlot: string, breakTimeSlot: string, timeSlotSun: any, timeSlotMon: any, timeSlotTue: any, timeSlotWed: any, timeSlotThu: any, timeSlotFri: any, timeSlotSat: any, weekStart: any, remarks: any) {
    let createdDate = new Date();
    let active = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/schsetup/${username}`, { orgid, effectiveFrom, effectiveTo, periodTimeSlot, breakTimeSlot, timeSlotSun, timeSlotMon, timeSlotTue, timeSlotWed, timeSlotThu, timeSlotFri, timeSlotSat, weekStart, remarks, createdDate, active });
  }

  updateSchedule(username: string, id: number, orgid: any, effectiveFrom: string, effectiveTo: string, periodTimeSlot: string, breakTimeSlot: string, timeSlotSun: any, timeSlotMon: any, timeSlotTue: any, timeSlotWed: any, timeSlotThu: any, timeSlotFri: any, timeSlotSat: any, weekStart: any, remarks: any, active: any,) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/schsetup/${username}/${id}`, { id, orgid, effectiveFrom, effectiveTo, periodTimeSlot, breakTimeSlot, timeSlotSun, timeSlotMon, timeSlotTue, timeSlotWed, timeSlotThu, timeSlotFri, timeSlotSat, weekStart, remarks, active });
  }

  getSchedule(id:number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/schsetup/${id}`);
  }

  previewEmptySchedule(username:string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/schmatrix/${username}`);
  }

  getScheduleDetailsPreview(username:string, reportId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/schmatrixbyrepid/${username}/${reportId}`);
  }

  schedulePreviewAction(orgId: number,id:number,lang:string,username:string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/generatereport200/${orgId}/${id}/${lang}/${username}`);
  }

  scheduleDetailsPreviewAction(orgId: number,id:number,lang:string,username:string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/generatereport300/${orgId}/${id}/${lang}/${username}`);
  }

  getAllScheduleHeaders(orgId: number,year:number,semester:number,grade:number, active: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/schheaders/${orgId}/${year}/${semester}/${grade}/${active}`);
  }

  addScheduleHeader(username: string, orgid: number,yearid:number,semesterid:number,gradeid:number, effectiveDateFrom: string, effectiveDateTo: string, scheduleStatus: string, active: string) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/schheaders/${username}`, { orgid, yearid,semesterid,gradeid,effectiveDateFrom, effectiveDateTo, scheduleStatus, active});
  }

  updateScheduleHeader(username: string, id: number, orgid: any,yearid:number,semesterid:number,gradeid:number, effectiveDateFrom: string, effectiveDateTo: string, scheduleStatus: string, active: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/schheaders/${username}/${id}`, { id, orgid, yearid,semesterid,gradeid,effectiveDateFrom, effectiveDateTo, scheduleStatus, active });
  }

  getScheduleHeaderById(id:number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/schheaders/${id}`);
  }

  getScheduleDetailByHeaderId(id:number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/schdetailsbyheader/${id}`);
    // return this.http.get<any>(
    //   `${environment.API_URL_ADM}/api/schdetails`);
  }

  deleteScheduleSectionById(username: string, id:number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/schdetails/${username}/${id}`);
  }

  getScheduleDetailSummary(orgid: number, yearid: number, semesterid: number, gradeid: number, scheduleid: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/schgradesubjectstatus/${orgid}/${yearid}/${semesterid}/${gradeid}/${scheduleid}`);
  }

  addScheduleDetailSection(username: string, orgid: number,yearid:number,semesterid:number,gradeid:number, schHeaderid: number, schDay: string, schDayType: string, schTimeFrom: string, schTimeTo:string, groupid: number, subjectid: number, primaryTeacherid: number, secondaryTeacherid: number) {
    let active:string = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/schdetails/${username}`, { orgid, yearid,semesterid,gradeid,schHeaderid, schDay, schDayType, schTimeFrom, schTimeTo, groupid, subjectid, primaryTeacherid, secondaryTeacherid, active});
  }

  getDays(orgid: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/schsetupdaysbyorg/${orgid}`);
  }

  getScheduleDetailSlotById(id:number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/schdetails/${id}`);
  }

  updateScheduleDetailSlot(username: string, slotData:any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/schdetails/${username}/${slotData?.id}`, slotData);
  }
}
